import { render, staticRenderFns } from "./OtherIncomeEditing.vue?vue&type=template&id=c1a0b6bc&scoped=true"
import script from "./OtherIncomeEditing.vue?vue&type=script&lang=js"
export * from "./OtherIncomeEditing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a0b6bc",
  null
  
)

export default component.exports